import React from 'react';
import { RiDeleteBin2Line } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';

interface MainDeleteButtonProps {
  onClick: () => void;
  id?: string;
  className?: string;
  iconSize?: string;
}

const MainDeleteButton: React.FC<MainDeleteButtonProps> = ({
  id = 'multi-delete-button',
  onClick,
  className = 'btn btn-soft-danger d-flex align-items-center',
  iconSize = '20px',
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    onClick();
  };

  return (
    <>
      <button
        className={className}
        id={id}
        data-testid={id}
        onClick={handleClick}
      >
        <RiDeleteBin2Line size={iconSize} className="align-center mx-1" />
        {t('Delete')}
      </button>
    </>
  );
};

export default MainDeleteButton;
